import * as Immutable from 'seamless-immutable';
import { Action } from 'redux';
import { isType } from 'typescript-fsa/lib';
import { updateProductEntities } from './products.actions';
import { AppState } from '../../reducers';
import { isEmpty, reject, isNil, map, values, find, propEq, uniq } from 'ramda';
import * as R from 'ramda';

export interface Product {
  id: number;
  name: string;
  imageUrl?: string;
  brand?: {
    id: number;
    name: string;
  };
}

export interface Products {
  [key: number]: {
    byId: {
      [key: string]: Product;
    };
  };
}

const initialState = Immutable.from<Products>({});

export type ProductState = Products & Immutable.ImmutableObject<Products>;

export default function reduce(
  state: ProductState = initialState,
  action: Action
) {
  if (isType(action, updateProductEntities)) {
    const {
      payload: { appId, products },
    } = action;

    if (!products) {
      return state;
    }

    return state.merge(
      {
        [appId]: {
          byId: products,
        },
      },
      { deep: true }
    );
  }

  return state;
}

export function getProductsByIds(
  state: AppState,
  appId: number,
  ids: number[]
): Product[] {
  if (isEmpty(ids)) {
    return [];
  }
  const {
    entities: { products },
  } = state;

  return reject(
    isNil,
    map(
      id => products[appId] && products[appId].byId && products[appId].byId[id],
      uniq(ids)
    )
  );
}

export function getProductsByAppId(state: AppState, appId: number) {
  const {
    entities: { products },
  } = state;
  return products[appId] && values(products[appId].byId);
}

export function getProductById(
  state: AppState,
  appId: number,
  productId: number
): Product | undefined {
  const products = getProductsByIds(state, appId, [productId]);
  if (!products || products.length === 0) {
    return;
  }

  return find(propEq('id', productId))(products) as Product | undefined;
}

export function getProductIdsByAppId(state: AppState, appId: number) {
  const productsByAppIdLens = R.lensPath([
    'entities',
    'products',
    appId,
    'byId',
  ]);

  return R.keys(R.view(productsByAppIdLens, state)) || [];
}



// WEBPACK FOOTER //
// ./src/store/Entities/Products/products.reducer.ts